import { PageHeader, type PageHeaderProps } from '@/widgets/page-header';

type PageWithHeaderLayoutProps = {
	children: React.ReactNode;
} & PageHeaderProps;

const PageWithHeaderLayout = ({
	children,
	...props
}: PageWithHeaderLayoutProps) => {
	return (
		<div className="flex h-full flex-col bg-mantang-white">
			<PageHeader {...props} />
			{children}
		</div>
	);
};

export default PageWithHeaderLayout;
